import React, { useState } from "react";
import { MDBBtn as Button } from "mdb-react-ui-kit";
import Modal from "react-bootstrap/Modal";

function EmployeeCertificateModal({ show, handleClose }) {
  const [certificateData, setCertificateData] = useState("");
  return (
    <Modal show={show} size="lg" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Certificate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Certification Type</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Certification Name</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>License #</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Issue Date</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Expiry Date</div>
          <input style={{ width: "70%" }} />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Image</div>
          <input style={{ width: "70%" }} type="file" />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            width: "100%",
            padding: "1%",
          }}
        >
          <button
            style={{
              backgroundColor: "var(--primary)",
              color: "var(--light)",
              borderRadius: "10px",
              padding: "1.5%",
              border: "none",
            }}
          >
            Save
          </button>
          {/* <button
            style={{
              backgroundColor: "var(--light)",
              color: "var(--dark)",
              borderRadius: "10px",
              padding: "1.5%",
              border: "none",
              marginLeft: "2%",
            }}
          >
            Cancel
          </button> */}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default EmployeeCertificateModal;
